/*
  Docs: https://hexdocs.pm/phoenix_live_view/js-interop.html#client-hooks

  Usage: when using phx-hook, a unique DOM ID must always be set.

      <div phx-hook="ExampleHook" id="someUniqueId"></div>
*/

const ScrollPosition = {
    mounted() {
        const container = this.el;
        let scrollTimeout;

        // Detect when user scrolls near bottom
        container.addEventListener("scroll", () => {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                if (this.nearBottom()) {
                    this.pushEvent("load-more");
                }
            }, 100);
        });
    },

    nearBottom() {
        const container = this.el;
        console.log(container.scrollTop + container.clientHeight)
        return container.scrollTop + container.clientHeight >= container.scrollHeight - 300;
    }
};

export default ScrollPosition;
